<template>

        <v-container
        class="scroll-y"
        fluid
        >
        <v-row
        align="center"
        justify="center"
        >
        <v-col cols="10" md="10">
          <v-card class="ml-20 mr-20">
            <v-app-bar
            dark
            color="#2C3A47"
            >
            <v-btn icon>
              <v-icon>mdi-devices</v-icon>
            </v-btn>
          <v-toolbar-title>Device Type</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" persistent max-width="800px">
            <template v-slot:activator="{ on }">
                <v-btn color="red" v-on="on" outlined="">
                  <v-icon left>add</v-icon> ADD
                </v-btn>
            </template>
              <v-card>
                <v-form @submit.prevent="saveDeviceType" ref="deviceTypeData" lazy-validation enctype="multipart/form-data" autocomplete="off">
                  <v-card-title>
                    <span class="headline">Device Type</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-form ref="form" v-model="valid">
                        <v-text-field label="Device type*" type="number" v-model="deviceTypeData.deviceType" :rules="deviceTypeRules" color="#2C3A47" :counter="2"></v-text-field>
                        <v-text-field label="Device name*" v-model="deviceTypeData.deviceName" :rules="deviceNameRules" color="#2C3A47"></v-text-field>
                        </v-form>
                      </v-flex>               
                    </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#2C3A47" dark @click="close" outlined small>
                      <v-icon left>exit_to_app</v-icon> Close
                    </v-btn>
                    <v-btn color="light-green darken-4" dark type="submit" outlined small>
                      <v-icon left>save</v-icon> {{saveDialog}}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
          </v-dialog>
            </v-app-bar>
            <v-container>
              <v-card class="mx-auto elevation-19">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  color="#2C3A47"
                  >
                  </v-text-field>
                </v-card-title>
        <v-data-table
        item-key="id"
        :headers="headers"
        :items="deviceType"
        :search="search"
        >
         <template v-slot:[`item.updatedAt`]="{ item }">
      {{ formatDate(item.updatedAt) }}
    </template>
        <template v-slot:[`item.actions`]="{item}">
          <v-btn color="success" class="mx-2" fab x-small @click="editDeviceType(item)" outlined>
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn color="pink" fab x-small @click="deleteDeviceType(item._id)" outlined>
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-results>
            <v-alert :value="true" color="pink" icon="warning" dark>
              Your Search {{search}} does not exist.
            </v-alert>
        </template>

        </v-data-table>
              </v-card>
            </v-container>
          </v-card>
          <v-snackbar
          v-model="snackbar"
          top
          right
          :color="color"
          >
          {{text}}
          <v-btn
          color="black"
          text
          @click="snackbar = false"
          >
          Dissmiss
          </v-btn>

          </v-snackbar>
        </v-col>

        </v-row>

        </v-container>
  
</template>
<script>
import axios from "axios";
import moment from 'moment';
export default {
  props:{
    source: String
  },
  data: () => ({
    mini: false,
    dialog:false,
    fab: false,
    search:'',
    snackbar: false,
    text:'',
    color:'',
    deviceType:[],
    connectivityType:["Cellular","WiFi","BLE"],
    deviceTypeRules: [
        v => !!v || 'Device Type is required',
        v => v.length <= 2 || 'Customer ID needs to be 2 digits',
        v => v.length >= 2 || 'Customer ID needs to be 2 digits',
      ],
    deviceNameRules: [
        v => !!v || 'Device name is required'
      ],
    headers: [
        {text: 'Device Type', value: 'deviceType', sortable: true},
        {text: 'Device Name', value: 'deviceName', sortable: true},
        {text: 'Modified By', value: 'modifiedBy', sortable: true},
        {text: 'Last Modified Date', value: 'updatedAt', sortable: true},
        {text: 'Action', value: 'actions', sortable: false, width: '180px'},
    ],
    deviceTypeData: {
      deviceType: '',
      deviceName: '',
      modifiedBy: ''
    },
    default: {
      deviceType: '',
      deviceName: '',
      modifiedBy: ''
    },
    editedIndex: -1,
  }),
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  computed: {
    saveDialog() {
      return this.editedIndex === -1 ? 'Save' : 'Edit'
    }
  },
  mounted() {
    this.loadsDeviceType();
  },
  methods: {
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsDeviceType: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/device-type";
  axios.get(apiURL).then(res => {
    this.deviceType = res.data;
  }).catch(error => {
    console.log(error)
  });
},

    onScroll (e) {
      if(typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop(){
      this.$vuetify.goTo(0)
    },
    close(){
      this.dialog = false
      setTimeout(()=>{
        this.deviceTypeData = Object.assign({}, this.default)
        this.editedIndex = -1
      }, 300)
    },
    saveDeviceType: async function(){
        if(this.editedIndex > -1) {
         this.updateDeviceType();
        }else {
          this.createDeviceType();
        }
    },
    createDeviceType(){
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/create-device-type";
        axios.post(apiURL, {
        deviceType: this.deviceTypeData.deviceType ,
        deviceName: this.deviceTypeData.deviceName,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then(() => {
          this.close();
          this.loadsDeviceType();
          this.color = 'success'
          this.text ='Device Type has been successfully saved.'
          this.snackbar = true;
        }).catch(error => {
          console.log(error)
        });
    }},
    editDeviceType(item) {
      this.editedIndex = this.deviceType.indexOf(item)
      this.deviceTypeData = Object.assign({}, item)
      this.dialog = true
    },
    updateDeviceType(){
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + `/api/update-device-type/${this.deviceTypeData._id}`;
      axios.post(apiURL, {
        deviceType: this.deviceTypeData.deviceType ,
        deviceName: this.deviceTypeData.deviceName,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then((res) => {
        console.log(res)
        this.close();
        this.loadsDeviceType();
        this.color ='info'
        this.text = 'Device Type has been modified.'
        this.snackbar = true;
      }).catch(error => {
        console.log(error)
        console.log(this.$route.params.id)
      })
    }},
     deleteDeviceType(id){
  this.$swal({
                    title: 'Are you sure?',
                    text: "You will not be able to go back",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#00b894',
                    cancelButtonColor: '#d63031',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    }).then((result) => {
                        // Send request to the server
                         if (result.value) {
                               try {
                let apiURL = process.env.VUE_APP_API + `/api/delete-device-type/${id}`;
                let indexOfArrayItem = this.deviceType.findIndex(i => i._id === id);
                axios.delete(apiURL).then(() => {
                        this.deviceType.splice(indexOfArrayItem, 1);
                    }).catch(error => {
                        console.log(error)
                    });
                 this.$swal(
                         'Deleted!',
                         'Device Type has been deleted.',
                         'success'
                        )
                        //Notification error
                this.color = 'error'
                this.text = "Device Type has been deleted."
                this.snackbar = true;
                //Notification error
            }catch (error) {
             this.$swal("Failed!", "There was something wrong.", "warning");
            }
                         }
                    })
  
            },
  },

}
</script>

<style>
  .otp-input {
    width: 30px;
    height: 40px;
    margin: 0 4px;
    font-size: 20px;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;

  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>